module.exports = __webpack_public_path__ + "img/2corazon.ebe43495.png";